module.exports = function isRegExp(obj){return obj instanceof RegExp;};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isRegExp.js
 ** module id = 23
 ** module chunks = 0
 **/